import { ArrowRight16, Launch16 } from '@carbon/icons-react';
import './Stats.scss';

interface statsProps {
  contents: any;
  formLink: string;
}

const Stats = (statsProps: statsProps) => {
  const { contents, formLink } = statsProps;
  const parentClass = 'dora-assessment__stats';
  return (
    <div className={`${parentClass}`}>
      <div className={`${parentClass}-white-wrapper`}>
        <h3 className={`${parentClass}-title`}>{contents.statsTitle}</h3>
        <div className="bx--row">
          <div className={`bx--col ${parentClass}-number`}>
            <h3>39%</h3>
            <p>
              {contents.stats1}
              <sup>1</sup>
            </p>
          </div>
          <div className={`bx--col ${parentClass}-number`}>
            <h3>86%</h3>
            <p>
              {contents.stats2}
              <sup>2</sup>
            </p>
          </div>
        </div>
        <div className="bx--row">
          <div className={`bx--col ${parentClass}-number`}>
            <h3>204 days</h3>
            <p>
              {contents.stats3}
              <sup>1</sup>
            </p>
          </div>
          <div className={`bx--col ${parentClass}-number`}>
            <h3>73 days</h3>
            <p>
              {contents.stats4}
              <sup>1</sup>
            </p>
          </div>
        </div>
      </div>
      <div className={`${parentClass}-copy`}>
        <p className="pre-link">{contents.statsCopy}</p>
        <a href={formLink} className="link">
          {contents.statsCta} <ArrowRight16 />
        </a>
      </div>
      <div className={`${parentClass}-footnote`}>
        <hr />
        <ol>
          <li>
            <span>1. </span>
            <a href="https://www.ibm.com/reports/data-breach">
              {contents.footnote1Link}
            </a>
            <span>{contents.footnote1}</span>
          </li>
          <li>
            <span>2. </span>
            <a href="https://research.esg-global.com/reportaction/515201719/Marketing">
              {contents.footnote2Link} <Launch16 />
            </a>
            <span>{contents.footnote2}</span>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Stats;
